import { render, staticRenderFns } from "./productListFromMiniTools.vue?vue&type=template&id=248c8707&scoped=true&"
import script from "./productListFromMiniTools.vue?vue&type=script&lang=js&"
export * from "./productListFromMiniTools.vue?vue&type=script&lang=js&"
import style0 from "./productListFromMiniTools.vue?vue&type=style&index=0&id=248c8707&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248c8707",
  null
  
)

export default component.exports